// extracted by mini-css-extract-plugin
module.exports = {"shadow":"filter_shadow__3AD_E","textShadow":"filter_textShadow__ZXPRe","container":"filter_container__20uWE"};